import {
  EventEmitter,
  getTranslatedText,
  useIntl,
  withErrorBoundary,
  toast,
  useActivityTracker
} from '@nile/components/src';
import { SVGIcon } from '@superops/super-icons';
import { Badge, Button } from '@superops/ui-design-system';
import React, { useContext, useEffect, useState } from 'react';
import { Tooltip } from 'react-clone-tippy';
import { FormattedMessage } from 'react-intl';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import { setGlobalState } from '@nile/components/src/Managers/StateManager';

const GlobalTicketConversationAction = (props) => {
  const { data } = props;
  const intl = useIntl();
  const splitOptions = data?.data?.splitOptions;
  const notificationTemplateByConstant =
    data?.data?.notificationTemplateByConstant;
  const [loading, setIsLoading] = useState(false);
  const tabContext = useContext(TicketContext);

  const ticketId = data?.id;
  const requester = data?.data?.requester;
  const client = data?.data?.client;
  const subject = data?.data?.subject;
  const sop = data?.data?.sop;
  const ticket = {
    ticketId: ticketId,
    id: ticketId,
    requester: requester,
    client: client,
    sop: sop || null,
    subject: subject
  };

  const tabId = getTabId({ module: 'TICKET', data: ticket });

  const sendConversation = (status, suppressCloseNotification) => {
    setIsLoading(true);
    let variables = data?.formatData(data);
    const client = data?.mutationClient;
    const mutationAPI = data?.mutationAPI;
    const callBack = data?.callBack;
    if (status) {
      let statusInput = {
        status: status?.name
      };

      if (suppressCloseNotification) {
        statusInput = { ...statusInput, suppressCloseNotification: true };
      }
      variables = { ...variables, ticketInput: statusInput };
    }

    EventEmitter.dispatch('updateGlobalTicketConversationData', variables);
    useActivityTracker({
      event: 'Sent reply from the pop out editor'
    });
    client
      .mutate({
        mutation: mutationAPI,
        variables: variables
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.data) {
          toast('success', 'app.toast.ticket.update.success');
          EventEmitter.dispatch('refetchTicketAudit'); // To refetch ticket
          EventEmitter.dispatch('updateGlobalTicketConversationData', null); // To reset conversation data on errors on closure
          EventEmitter.dispatch('globalConversationClosed', data); // To check if action toolbar is disabled in chat feed container
          EventEmitter.dispatch('closeGlobalConversation', data?.id); // To close conversation tab
          if (callBack) {
            callBack('success', res);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const connectedDisclosure = splitOptions
    ? {
        disabled:
          data?.recipients?.length === 0 &&
          data?.conversationScope === 'PRIVATE',
        actions: splitOptions.map((el) => {
          return {
            content: (
              <div className="fx actr">
                <div className="fg1" onClick={() => sendConversation(el)}>
                  {el.content}
                </div>

                {notificationTemplateByConstant?.activated &&
                  el.statusType === 'close' && (
                    <span
                      onClick={() => {
                        sendConversation(el, true);
                      }}
                      className="fx actr mlauto ptr"
                    >
                      <Tooltip
                        html={
                          <div className="p3 f12">
                            {getTranslatedText(
                              intl,
                              'ticket.action.closeWithoutNotification'
                            )}
                          </div>
                        }
                        delay={400}
                        duration={250}
                        position="bottom"
                        distance={10}
                        inertia
                        trigger="mouseenter"
                        animation="shift"
                        animateFill={false}
                      >
                        <Badge
                          radial
                          status="attention"
                          // status={cancelNotify ? 'attention' : 'secondary'}
                          icon={
                            <SVGIcon
                              name="NotificationsBellCrossed"
                              size="sm"
                            />
                          }
                        />
                      </Tooltip>
                    </span>
                  )}
              </div>
            )
          };
        })
      }
    : null;
  return (
    <Button
      loading={loading}
      disabled={
        data?.recipients?.length === 0 && data?.conversationScope === 'PRIVATE'
      }
      onClick={() => sendConversation()}
      primary
      connectedDisclosure={connectedDisclosure}
      icon={!loading && <SVGIcon name="SendWhite" color="#fff" />}
    >
      <FormattedMessage id="ticket.details.chat.submit" />
    </Button>
  );
};

export default withErrorBoundary(GlobalTicketConversationAction);
